import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { Persona } from '../models'

import { ApiService } from './api.service'
import { Mapper } from './mapper.service'
import { Store } from './store'

@Injectable({
  providedIn: 'root'
})
export class UserPersonaService extends Store<Persona> {

  constructor(private api: ApiService) {
    super(null)
  }

  public findSelf(): void {
    this.getSelf().pipe(first())
      .subscribe(
        (data: any) => {
          const persona = Mapper.as<Persona>((data.result?.length && data.result[0]) || { }, Persona)
          this.setCurrent(persona)
        },
        error => {
          this.setCurrent(new Persona({ }))
        }
      )
  }

  public find(personaId: number, params?: any, options?: any): Observable<Persona> {
    return this.api.get(`personas/${personaId}`, { ...options, params: { ...params } }).pipe(
      first(),
      map(data => data.result)
    )
  }

  public getSelf(): Observable<any> {
    return this.api.get('personas/mine', { params: { type: 'self'}} )
  }

  public getOther(): Observable<any> {
    return this.api.get('personas/mine', { params: { type: 'other'}})
  }

  public getMine(): Observable<any> {
    return this.api.get('personas/mine')
  }
}
